<script setup lang="ts">
const route = useRoute();
const localePath = useLocalePath();

definePageMeta({
  layout: false,
});

await navigateTo(
  localePath({ path: "/directory", query: { ...route.query, view: "map" } }),
  { redirectCode: 301, replace: true }
);
</script>

<template>
  <div />
</template>
